import { useTranslation } from "react-i18next";
import {
  PurchaseProductContainer,
  PurchaseProductIntroductionContainer,
  PurchaseProductIntroductionTitleText,
  PurchaseProductIntroductionTitleImg,
  PurchaseCheckoutButton,
} from "../styles";
import { PRODUCTS, CURRENCY_LABEL } from "../../../../../constants/common";
import { ProductType } from "../../../Dashboard/BuyUp";
import { useHistory } from "react-router-dom";
import { List, UnOrderList } from "components/User/Evaluation/styles";

type Props = {
  currency: string;
  product: ProductType;
  isBuyUp: boolean;
};

const CorePro = (props: Props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const currencyLabel = CURRENCY_LABEL[props.currency];
  const price = props.product["price"][props.currency];

  const handleNext = () => {
    const queryString =
      "?product=" +
      (props.isBuyUp ? PRODUCTS.CoreProBuyUp : PRODUCTS.CorePro) +
      "&currency=" +
      props.currency +
      "&isBuyUp=" +
      (props.isBuyUp ? "true" : "false");
    history.push("/purchases-payment" + queryString);
  };

  return (
    <PurchaseProductContainer>
      <PurchaseProductIntroductionContainer>
        <div>
          <PurchaseProductIntroductionTitleText>
            {props.isBuyUp
              ? t(`user.purchase.order.product.${PRODUCTS.CoreProBuyUp}.title`)
              : t(`user.purchase.order.product.${PRODUCTS.CorePro}.title`)}
          </PurchaseProductIntroductionTitleText>
          <PurchaseProductIntroductionTitleImg name={PRODUCTS.CorePro} />
          <UnOrderList>
            <List>
              {props.isBuyUp
                ? t(`user.purchase.order.product.${PRODUCTS.CoreProBuyUp}.des1`)
                : t(`user.purchase.order.product.${PRODUCTS.CorePro}.des1`)}
            </List>
            <List>
              {props.isBuyUp
                ? t(`user.purchase.order.product.${PRODUCTS.CoreProBuyUp}.des2`)
                : t(`user.purchase.order.product.${PRODUCTS.CorePro}.des2`)}
            </List>
            <List>
              {props.isBuyUp
                ? t(`user.purchase.order.product.${PRODUCTS.CoreProBuyUp}.des3`)
                : t(`user.purchase.order.product.${PRODUCTS.CorePro}.des3`)}
            </List>
          </UnOrderList>
        </div>
        <div>
          <PurchaseCheckoutButton onClick={handleNext}>
            {t("user.purchase.order.checkout")} {currencyLabel + price}
          </PurchaseCheckoutButton>
        </div>
      </PurchaseProductIntroductionContainer>
    </PurchaseProductContainer>
  );
};

export default CorePro;
